import * as React from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, message, Modal } from "antd";
import { useAuth } from "@/component/Auth";
import styled from "styled-components";
import { conference } from "@/api";
import { checkStoredPlayTips } from "../pub";
// import AutoPlayMusic from "../automusic"
import { AnyType, Commond, ConferenceInterface, JoinMeetingInterrupt } from "@/types";
import {
  NORMALSETTINGKEY,
  METTINGPAGE_SAVED_MEETING_INFO,
  LOGININFOSTORE,
  LOGINTOKEN
} from "@/config/const";
import prompt from "antd-prompt";
import { notChromeMessage, storage } from "@/util";
import Checkbox from "antd/es/checkbox/Checkbox";

import * as consts from "@/config/const";
import isElectron from "is-electron";
import { checkLocalStorageKey } from "@/util";
import Default_Avatar from "@/assets/avatar.jpg";
import { useMqtt } from "@/hooks/use-mqtt";
import { useEffect } from "react";

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
  .atitle {
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    color: #999;
    margin-top: 30px;
  }
  .form {
    width: 280px;
  }
  .w280 {
    width: 280px;
  }
  .join {
    width: 280px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const JoinMeeting: React.FunctionComponent = (props) => {
  const auth = useAuth();
  // const { loggedIn, loginfo, updateLogInfo } = auth;
  const logInfo = storage.get(consts.LOGININFOSTORE);

  const history = useHistory();
  const [form] = Form.useForm();

  const settingItem: AnyType = storage.get(NORMALSETTINGKEY) as any;
  const { audio = true, mic = true, video = true } = settingItem;

  const [audioOn, setAudioOn] = React.useState(mic);
  const [videoOn, setVideoOn] = React.useState(video);
  const [simulcastOn, setSimulcastOn] = React.useState(false);
  const [speakerOn, setSpeakerOn] = React.useState(audio);
  const [monitorOn, setMonitorOn] = React.useState(false);

  const handleMonitorChange = (checked: boolean) => {
    setMonitorOn(checked);
    if (checked) {
      setAudioOn(false);
      setVideoOn(false);
    }
  };

  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = React.useState(false);
  const [passwordValue, setPasswordValue] = React.useState("");

  const loginfo = storage.get(LOGININFOSTORE);

  const { setCallback } = useMqtt()

  useEffect(() => {
    setCallback(Commond.inviteMeeting, async (payload: { conferenceNo: string, userId: string }) => {
      const info = storage.get(consts.LOGININFOSTORE)

      if (payload.userId === info.userId) {
        // message.info("您有新的会议邀请，请注意查看！");
        console.log("收到会议邀请", payload);

        checkStoredPlayTips(payload.conferenceNo);
        const con: any = await getConferenceInfo(payload.conferenceNo, info.username);
        //打印con里面的信息
        console.log(`[JoinMeeting] con=${JSON.stringify(con)}`);
        if (con.code === -1) {
          message.warn(con.message || "加入会议失败");
        }
        console.log(con,"没有peerid")
        //异常情况处理
        if (con.code !== undefined) {
          let code = con.code;
          let data = con.data;
          if (code === JoinMeetingInterrupt.passwordNeeded) {
            //请输入会议密码,弹出会议密码输入框,并验证会议密码是否正确
            console.log(`[JoinMeeting] password needed`);
            showPasswordInputDialog(true);

            message.error(con.message);
            // return;
          } else if (code === JoinMeetingInterrupt.wrongPassword) {
            //输入的会议密码不正确
            message.error(con.message);
          }  else {
            message.error(con.message);
          }
        } else {
          goMetting(con, info.userName);
        }

        setCallback(Commond.inviteMeeting, () => {})
      }
    })
  }, [])

  const getConferenceInfo = async (
    conferenceNo: string,
    userName: string,
    password?: string
  ) => {
    try {
      const ret = await conference.conferenceJoin(
        {
          conferenceNo,
          userName,
          password,
        },
        {
          "X-Conference-No": conferenceNo, //	${conferenceNo}	会议号
          "X-Device": "1", //	8
        }
      );
      //需要先判断ret的code是200还是600xxx
      console.log(`[JoinMeeting] ret=${JSON.stringify(ret)}`);
      console.log(`[获取到的roomid] ret=${ret.roomid}`);
      const con = ret.conference as ConferenceInterface;
      con.attendList = ret.attendList;
      con["X-Channel-Token"] = ret["X-Channel-Token"];
      con["X-Conference-Token"] = ret["X-Conference-Token"];
      con.roleCode = ret.roleCode;
      con.roomid = ret.roomid;
      con.roleName = ret.roleName;
      //con.userId = ret.userid;
      con.userId = monitorOn ? `monitor${ret.userid}` : ret.userid;
      return con;
    } catch (e) {
      return e;
    }
  };

  const goMetting = async (conf: ConferenceInterface, userName: string) => {
    console.log(conf,'这是什么数据')
    storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
    const url = `/meeting/${
      conf.roomId
    }?peerId=${conf.roomid}_${conf.userId}&username=${userName}&audio=${monitorOn ? false : !!audioOn}&video=${monitorOn ? false : !!videoOn}&speaker=${!!speakerOn}&simulcast=${!!simulcastOn}`;
    
    console.log(url,'这是加入的网址')
    history.push(url);
  };

  const join = async () => {
      //检查是否需要播放提示音
       
    // const browserErrMsg = notChromeMessage();
    // if (browserErrMsg) {
    //   message.error(browserErrMsg);
    //   return;
    // }
    const values = await form.validateFields();
    const { conferenceNo, userName, password } = values as AnyType;
    checkStoredPlayTips( conferenceNo);
    const con: any = await getConferenceInfo(conferenceNo, userName, password);
    //打印con里面的信息
    console.log(`[JoinMeeting] con=${JSON.stringify(con)}`);
    if (con.code === -1) {
      message.warn(con.message || "加入会议失败");
    }
    console.log(con,"没有peerid")
    //异常情况处理
    if (con.code !== undefined) {
      let code = con.code;
      let data = con.data;
      if (code === JoinMeetingInterrupt.passwordNeeded) {
        //请输入会议密码,弹出会议密码输入框,并验证会议密码是否正确
        console.log(`[JoinMeeting] password needed`);
        showPasswordInputDialog(true);
        
        message.error(con.message);
        // return;
      } else if (code === JoinMeetingInterrupt.wrongPassword) {
        //输入的会议密码不正确
        message.error(con.message);
      }  else {
        message.error(con.message);
      }
    } else {
      goMetting(con, userName);
    }
  };

  const checkPassword = async () => {
    const password = await prompt({
      title: "会议密码",
      placeholder: "请输入会议密码",
      rules: [
        {
          required: true,
          message: "请输入会议密码",
        },
      ],
      modalProps: {
        width: "400px",
      },
    });
    return password || "";
  };

  const showPasswordInputDialog = (bShow: boolean) => {
    setIsPasswordDialogOpen(bShow);
  };

  // const handleShowPasswordInputDialogOk = async () => {
  //   //获取到password,直接再调用加会接口加入会议
  //   const values = await form.validateFields();
  //   const { conferenceNo, userName } = values as AnyType;
  //   const con: any = await getConferenceInfo(
  //     conferenceNo,
  //     userName,
  //     passwordValue
  //   );
  //   //异常情况处理
  //   if (con.code !== undefined) {
  //     let code = con.code;
  //     let data = con.data;
  //     if (code === JoinMeetingInterrupt.passwordNeeded) {
  //       //请输入会议密码,弹出会议密码输入框,并验证会议密码是否正确
  //       console.log(`[JoinMeeting] password needed`);
  //       //showPasswordInputDialog(true);
  //       return;
  //     } else if (code === JoinMeetingInterrupt.wrongPassword) {
  //       //输入的会议密码不正确
  //       console.log(`[JoinMeeting] password is wrong`);
  //     }
  //   } else {
  //     goMetting(con, userName);
  //   }

  //   setIsPasswordDialogOpen(false);
  // };

  // const handleShowPasswordInputDialogCancel = () => {
  //   setIsPasswordDialogOpen(false);
  // };

  const passwordValueChange = (e: any) => setPasswordValue(e.target.value);

  return (
    <Container>
      <div className="atitle">加入会议</div>
      {/* <AutoPlayMusic /> */}
      <Form form={form} className="form">
        <Form.Item
          className="mb20"
          name="conferenceNo"
          label=""
          rules={[{ required: true, message: "请输入会议号" }]}
        >
          <Input placeholder="请输入会议号" />
        </Form.Item>
        <Form.Item
          className="mb20"
          name="userName"
          label=""
          rules={[{ required: true, message: "请输入用户名" }]}
          initialValue={loginfo.realName}
        >
          <Input placeholder="请输入用户名" />
        </Form.Item>
        <Form.Item
          className="mb20"
          name="password"
          label=""
        >
          <Input placeholder="请输入会议密码（可选）" />
        </Form.Item>
      </Form>
      <div className="w280">
        <Checkbox
          checked={audioOn}
          onChange={(e) => setAudioOn(e.target.checked)}
        >
          开启麦克风
        </Checkbox>
      </div>

      {/* <div className="w280 mt15">
        <Checkbox
          checked={speakerOn}
          onChange={(e) => setSpeakerOn(e.target.checked)}
        >
          开启扬声器
        </Checkbox>
      </div> */}

      <div className="w280 mt15">
        <Checkbox
          checked={videoOn}
          onChange={(e) => setVideoOn(e.target.checked)}
        >
          开启摄像头
        </Checkbox>
      </div>
      {/* <div className="w280 mt15">
        <Checkbox
          checked={simulcastOn}
          onChange={(e) => setSimulcastOn(e.target.checked)}
        >
          开启多流
        </Checkbox>
      </div> */}

      <div className="w280 mt15">
        <Checkbox
          checked={monitorOn}
          onChange={(e) => handleMonitorChange(e.target.checked)}
        >
          旁听模式
        </Checkbox>
      </div>

      <div className="join mt20">
        <Button type="primary" onClick={join} className="w280 mt10">
          加入会议
        </Button>
      </div>
{/* 
      <Modal
        title="请输入入会密码"
        width={300}
        centered
        visible={isPasswordDialogOpen}
        onOk={handleShowPasswordInputDialogOk}
        onCancel={handleShowPasswordInputDialogCancel}
        okText="加入"
        cancelText="取消"
      >
        <Input
          value={passwordValue}
          onChange={passwordValueChange}
          placeholder="会议密码"
        />
      </Modal> */}
      {/* <MeetingContext.Provider value={{ participants, service }}>
        <VideoCard participant={me} showTag={false} showTool={false} />
      </MeetingContext.Provider> */}
    </Container>
  );
};

export default JoinMeeting;
